import gsap from 'gsap';
// import { sizes } from "@/js/sizes";


export default {
	name: "AppFaq",
	data() {
		return {
			currentIndexFAQ: 0,
			tabsContainer: null,
			distanceScrollTab: 0,
			limitScrollTab: 0,
			currentIndexQuestion: 0,
			isQuestionClose: true,
			currentQuestionOpen: null,
			prevQuestion: null,
			animDelay: 0,
			// questionHeight: 0
		}
	},
	created() {
		window.addEventListener('resize', this.handleResize);
	},
	mounted() {
		this.tabsContainer = document.querySelector('.faq__container__tabs__wrapper__tab');
		this.currentTabSeleted = document.querySelector(`div[data-index="${0}"]`)
		this.limitScrollTab = this.tabsContainer.offsetWidth - window.innerWidth;
		// this.questionHeight = document.querySelector('.faq__questions__wrapper__question__content').offsetHeight

		document.querySelectorAll('.faq__questions__wrapper__question__content').forEach(el => {
			el.addEventListener('mousemove', this.moveBar)
		})

		this.observeFaq();

		this.checkIfMobile()

	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize);
	},
	methods: {
		observeFaq() {
			const faq = document.querySelector('.faq');
			let options = {
				rootMargin: "200px",
				threshold: 0
			}

			let observer = new IntersectionObserver(entries => {
				entries.forEach(enter => {
					if (enter.intersectionRatio > 0) {
						this.enterAnim()
						observer.unobserve(faq)
					}
				})
			}, options);

			observer.observe(faq);
		},
		checkIfMobile() {
			if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
				this.$refs.bar.style.display = 'none'
				document.querySelectorAll('.faq__questions__wrapper__question__content').forEach(el => {
					el.classList.remove('var_hover')
				})
			} else {
				this.$refs.bar.style.display = 'block'
				document.querySelectorAll('.faq__questions__wrapper__question__content').forEach(el => {
					el.classList.add('var_hover')
				})
			}
		},
		enterAnim() {
			let tlTabs = gsap.timeline({
				scrollTrigger: {
					trigger: '.faq',
					start: "top bottom-=5%",
					end: "bottom bottom",
					scrub: 0.8
				}
			});

			const ques = document.querySelector('.faq__questions__wrapper__question')

			tlTabs
				.fromTo(this.$refs.questions, { scaleY: 0, transformOrigin: 'top' }, { scaleY: 1 })
				.fromTo('.faq__container__tabs__wrapper__tab__single', { y: 50, autoAlpha: 0 }, { y: 0, autoAlpha: 1, stagger: 0.1 }, '-=0.1')
				.fromTo(ques.children, { x: 50, autoAlpha: 0 }, { x: 0, autoAlpha: 1, stagger: 0.12 }, '-=0.2')
		},
		moveBar(ev) {
			if (this.prevQuestion != ev.currentTarget) {
				const firstY = this.currentTabSeleted.getBoundingClientRect().y
				gsap.timeline()
					.to(this.$refs.bar, { duration: 0.26, y: -(firstY - ev.currentTarget.getBoundingClientRect().y), height: ev.currentTarget.children[1].offsetHeight })


				// const tab = document.querySelector('.faq__questions__wrapper__question[data-index="0"]')
				// const question = tab.querySelectorAll('.faq__questions__wrapper__question__content')
				// const questionNumb = Array.from(question).indexOf(ev.currentTarget)

				// gsap.timeline()
				// .to(this.$refs.bar, {duration: 0.26, y: this.questionHeight * questionNumb, height: ev.currentTarget.children[1].offsetHeight})

			}

			this.prevQuestion = ev.currentTarget
		},
		hideBar() {
			this.prevQuestion = null
			gsap.to(this.$refs.bar, { duration: 0.26, height: 0 })
		},
		toggleFAQ(index) {
			this.prevTabSeleted = document.querySelector(`div[data-index="${this.currentIndexFAQ}"]`)
			this.currentIndexFAQ = index;
			this.questionAnimationLeaveSame(this.currentIndexQuestion);
			this.currentTabSeleted = document.querySelector(`div[data-index="${this.currentIndexFAQ}"]`)
		},
		toggleQuestion(index) {
			if (this.currentIndexQuestion == index && !this.isQuestionClose) {
				this.isQuestionClose = !this.isQuestionClose;
				this.questionAnimationLeaveSame(index);
			} else if (this.currentIndexQuestion == index && this.isQuestionClose) {
				this.isQuestionClose = !this.isQuestionClose;
				this.questionAnimationEnterSame(index)
			} else {
				this.questionAnimation(index, this.currentIndexQuestion);
				this.isQuestionClose = false;
			}

			this.currentIndexQuestion = index;
		},
		questionAnimation(newEl, oldEl) {
			const newElement = this.currentTabSeleted.querySelector(`div[data-question="${newEl}"]`)
			const oldElement = this.currentTabSeleted.querySelector(`div[data-question="${oldEl}"]`)
			this.currentQuestionOpen = newElement;

			const newElementHeight = newElement.children[0].offsetHeight;

			gsap.to(newElement, { duration: 0.5, height: `${newElementHeight}` })
			gsap.to(oldElement, { duration: 0.5, height: 0 })

		},
		questionAnimationLeaveSame(sameEl) {
			const sameElement = this.currentTabSeleted.querySelector(`div[data-question="${sameEl}"]`)
			this.currentQuestionOpen = false;

			gsap.timeline().to(sameElement, { duration: 0.5, height: `${0}` })
				.set(sameElement, { clearProps: 'height' });
		},
		questionAnimationEnterSame(sameEl) {
			const sameElement = this.currentTabSeleted.querySelector(`div[data-question="${sameEl}"]`)
			const sameElementHeight = sameElement.children[0].offsetHeight;
			this.currentQuestionOpen = sameElement;

			gsap.to(sameElement, { duration: 0.5, height: `${sameElementHeight}` })
		},
		beforeEnterTab(el) {
			gsap.set(el, { position: 'absolute', top: 0, left: 0, opacity: 0, x: window.innerWidth, width: '100%' })
		},
		enterTab(el, done) {
			el.style.opacity = 1
			el.style.transform = 'translate(0, 0)'
			const wrapper = document.querySelector('.faq__questions__wrapper');

			el.children.forEach((elem, i) => {
				gsap.fromTo(elem, { x: 40, opacity: 0 }, { duration: 0.5, x: 0, opacity: 1, delay: this.animDelay + 0.6 + i * 0.05 })
			})

			gsap.fromTo(wrapper, { duration: 0.5, height: this.prevTabSeleted.offsetHeight }, {
				height: el.offsetHeight, delay: this.animDelay + 0.6, onComplete: () => {
					done()
				}
			})
		},
		afterEnterTab(el) {
			const wrapper = document.querySelector('.faq__questions__wrapper');

			gsap.set(el, { clearProps: 'position,top,left,width' })
			gsap.set(wrapper, { clearProps: 'height' })
		},
		beforeLeaveTab(el) {
			gsap.set(el, { position: 'absolute', top: 0, left: 0, width: '100%' })
		},
		leaveTab(el, done) {
			this.isQuestionClose = true;

			el.children.forEach((elem, i) => {
				gsap.to(elem, {
					duration: 0.5, x: -40, opacity: 0, delay: this.animDelay + i * 0.05, onComplete: () => {
						if (i === el.children.length - 1) {
							done()
						}
					}
				})
			})
		},
		handleResize() {
			this.checkIfMobile()
			if (this.currentQuestionOpen) {
				gsap.set(this.currentQuestionOpen, { height: `${this.currentQuestionOpen.children[0].offsetHeight + 25}` })
			}
		}
	}
}